import AlarmIcon from './AlarmIcon';

export default AlarmIcon;
